import { Twitter, Facebook, Instagram, Linkedin, Youtube, Github, Mail, Globe, Rss, Music2 } from "lucide-react";

export const PLATFORM_META = {
  twitter:   { label: "Twitter / X",  Icon: Twitter,   placeholder: "https://twitter.com/handle" },
  facebook:  { label: "Facebook",     Icon: Facebook,  placeholder: "https://facebook.com/page" },
  instagram: { label: "Instagram",    Icon: Instagram, placeholder: "https://instagram.com/handle" },
  linkedin:  { label: "LinkedIn",     Icon: Linkedin,  placeholder: "https://linkedin.com/company/…" },
  youtube:   { label: "YouTube",      Icon: Youtube,   placeholder: "https://youtube.com/@channel" },
  github:    { label: "GitHub",       Icon: Github,    placeholder: "https://github.com/org" },
  tiktok:    { label: "TikTok",       Icon: Music2,    placeholder: "https://tiktok.com/@handle" },
  email:     { label: "Email",        Icon: Mail,      placeholder: "hello@example.com" },
  website:   { label: "Website",      Icon: Globe,     placeholder: "https://example.com" },
  rss:       { label: "RSS",          Icon: Rss,       placeholder: "https://example.com/feed.xml" },
};

export const PLATFORM_KEYS = Object.keys(PLATFORM_META);

export function normaliseSocialHref(platform, url) {
  const u = (url || "").trim();
  if (!u) return "#";
  if (platform === "email") {
    return u.startsWith("mailto:") ? u : `mailto:${u}`;
  }
  return u.startsWith("http") ? u : `https://${u}`;
}
